import { Component } from '@angular/core';
import {Token} from "../../../modules/auth/models/token";
import {AuthService} from "../../../modules/auth/services/auth-service";
import Swal from "sweetalert2";
import {ToastrService} from "ngx-toastr";

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrl: './sidebar.component.css',
    standalone: false
})
export class SidebarComponent {
  token: Token | undefined;
  showModalFeedback = false;
  tipoSaas = 1;

  constructor(private tokenService: AuthService,
              private toastr: ToastrService) {
    this.token = this.tokenService.AccessToken;
  }

  logoff(){
    Swal.fire({
      title: 'Deseja realmente sair?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: '#4973cf',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if(result.value){
        this.tokenService.logoff();
        this.toastr.warning("Volte sempre!");
      }
    });
  }

  abrirModal(){
    this.showModalFeedback = true;
  }

  fecharModal(){
    this.showModalFeedback = false;
  }
}
